<template>
  <div
    :class="{ hide: toggle, reversed: buttonReversed }"
    class="collapse collapse_price"
    v-bind="$attrs"
  >
    <div class="collapse_header mb2">
      <button
        v-if="buttonReversed"
        class="btn collapse_header__btn fg"
        @click="toggle = !toggle"
      >
        <slot
          :toggle="toggle"
          name="title"
        >
          <i
            :class="toggle ? 'i-plus' : 'i-minus'"
            class="f18 m0"
          />
          <span class="white f16"><slot name="label" /></span>
        </slot>
      </button>
      <button
        v-else
        class="btn collapse_header__btn fg"
        @click="toggle = !toggle"
      >
        <slot
          :toggle="toggle"
          name="title"
        >
          <span class="white f16"><slot name="label" /></span>
          <i
            :class="toggle ? 'i-plus' : 'i-minus'"
            class="f18 m0"
          />
        </slot>
      </button>
    </div>
    <div class="collapse_body">
      <slot name="items">
        <div
          v-for="(item, index) in items"
          :key="`collapse-item-${index}${itemKey}`"
        >
          <slot
            :item="item"
            name="item"
          >
            {{ item }}
          </slot>
        </div>
      </slot>
    </div>
  </div>
</template>

<script generic="T" lang="ts" setup>
const props = defineProps<{
  items?: T
  defaultExpanded?: boolean
  itemKey?: string
  buttonReversed?: boolean
}>();
const emit = defineEmits(['change']);
const toggle = ref(!props.defaultExpanded);

watch(() => toggle.value, (value) => {
  emit('change', value);
});
</script>

<style lang="scss" scoped>
.collapse {
  &.reversed {
    background: var(--surfaces-low-container);

    .collapse_header {
      .collapse_header__btn {
        justify-content: flex-start;
        padding: 1.6rem 1.2rem !important;
      }

      i {
        color: var(--accent-primary);
      }
    }

    .collapse_body {
      padding: 0 10px 10px;
    }
  }

  &_header {
    position: relative;

    &__btn {
      width: 100%;
      justify-content: space-between;
      padding: 1.6rem 0 !important;
      border-radius: 0;
      color: var(--surfaces-on-surface-variable);
      gap: 16px;

      &:hover {
        color: var(--accent-on-accent-secondary);
      }
    }

    i {
      transition: transform 0.3s;
      transform: rotate(180deg);
      margin: 0 0.5rem;
    }

  }

  &_body {
    opacity: 1;
    visibility: visible;
    transition: 0.3s;
    width: 100%;
    transform: unset;
  }

  &.hide {
    .collapse {
      &_header {
        i {
          transform: unset;
        }
      }

      &_body {
        opacity: 0;
        padding: 0;
        max-height: 0;
        visibility: hidden;
        overflow: hidden;
        transform: translateX(-1rem);
      }
    }
  }
}
</style>
